import {
  ActivityAssociation,
  Contact,
  DataProduct,
  DataVendor,
} from 'v2/models';
import { useContact } from '../queries/useContact';
import { useDataVendor } from 'v2/queries/useDataVendor';
import { useDataProduct } from 'v2/queries/useDataProduct';
import { getContactNameToDisplay } from 'v2/utils/ContactUtils';
import { getActivityAssociationName } from 'v2/utils/activityUtils';

const getDisplayLabel = (
  contact: Contact | undefined,
  vendor: DataVendor | undefined,
  product: DataProduct | undefined,
  table_name: string
): string => {
  if (table_name === 'Contact' && contact) {
    return getContactNameToDisplay(contact);
  }

  if (table_name === 'DataVendor' && vendor) {
    return vendor.name;
  }

  if (table_name === 'DataProduct' && product) {
    return product.name;
  }
  return '';
};

export const useActivityAssociationLabel = (
  association: ActivityAssociation
) => {
  const { table_name, object_id } = association || {};
  const { data: contact } = useContact({
    id: object_id,
    enabled: table_name === 'Contact',
  });
  const { data: vendor } = useDataVendor({
    id: object_id,
    enabled: table_name === 'DataVendor',
  });
  const { data: product } = useDataProduct({
    id: object_id,
    enabled: table_name === 'DataProduct',
  });

  const label =
    getDisplayLabel(contact, vendor, product, table_name) ||
    getActivityAssociationName(association.name);

  return label;
};
